import type { ClientConfig } from './config';

export const oidcSettings = {
    authority: '',
    clientId: '',
    redirect_uri: `${window.location.origin}/oidc`,
    responseType: 'code',
    scope: 'openid profile email',
    post_logout_redirect_uri: window.location.origin,
    automaticSilentRenew: true,
};

export function configureOidc(config: ClientConfig): void {
    oidcSettings.authority = config.authority;
    oidcSettings.clientId = config.clientId;
}
